import { isSmall } from '../../../utils/breakpoints';
import isDesktop from '../../../utils/desktop/isDesktop';
import { selectIsDesktopNowPlayingEnabled } from '../../../selectors/config';
import { selectIsMobile } from '../../../selectors/app';

export default function shouldOpenNowPlayingDialog(state) {
  const { app, dialog } = state;
  const isDesktopNowPlayingEnabled = selectIsDesktopNowPlayingEnabled(state);
  const showOnMobile = selectIsMobile(state) && !isSmall(app.breakpoint);
  const showOnDesktop = isDesktop() && isDesktopNowPlayingEnabled;

  return (showOnDesktop || showOnMobile) && !dialog.isNowPlayingDialogOpen;
}
